<script setup lang="ts">
import {
  Activity,
  BadgeDollarSign,
  BookOpenText,
  Bot,
  BrainCircuit,
  Cable,
  CheckSquare2,
  ChevronLeft,
  CircleGauge,
  FolderKanban,
  Goal,
  Mail,
  Images,
  Menu,
  MonitorUp,
  Network,
  Settings,
  Sparkles,
  Workflow,
} from 'lucide-vue-next'
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useConnectionStore } from '@/stores/domain'
import BrandMark from './BrandMark.vue'

const expanded = ref(false)
const { required } = storeToRefs(useConnectionStore())

const navigation = [
  { label: 'Manager', to: '/app/manager', icon: Sparkles },
  { label: 'Projects', to: '/app/projects', icon: FolderKanban },
  { label: 'Goals', to: '/app/goals', icon: Goal },
  { label: 'Agents', to: '/app/agents', icon: Bot },
  { label: 'Workflows', to: '/app/workflows', icon: Workflow },
  { label: 'Executions', to: '/app/executions', icon: Activity },
  { label: 'Operations', to: '/app/operations', icon: Network },
  { label: 'Approvals', to: '/app/approvals', icon: CheckSquare2 },
  { label: 'Connections', to: '/app/connections', icon: Cable },
  { label: 'Communications', to: '/app/communications', icon: Mail },
  { label: 'Media', to: '/app/media', icon: Images },
  { label: 'Knowledge', to: '/app/knowledge', icon: BookOpenText },
  { label: 'Browser', to: '/app/browser', icon: MonitorUp },
  { label: 'Advisor', to: '/app/advisor', icon: BrainCircuit },
  { label: 'Usage', to: '/app/usage', icon: CircleGauge },
  { label: 'Billing', to: '/app/billing', icon: BadgeDollarSign },
]
</script>

<template>
  <button class="mobile-menu" type="button" aria-label="Open navigation" @click="expanded = true">
    <Menu :size="20" />
  </button>
  <div v-if="expanded" class="sidebar-scrim" @click="expanded = false"></div>
  <aside class="sidebar" :class="{ 'sidebar--expanded': expanded }">
    <div class="sidebar__brand">
      <BrandMark />
      <button
        type="button"
        class="sidebar__close"
        aria-label="Close navigation"
        @click="expanded = false"
      >
        <ChevronLeft :size="19" />
      </button>
    </div>

    <nav class="sidebar__nav" aria-label="Application navigation">
      <RouterLink
        v-for="item in navigation"
        :key="item.to"
        :to="item.to"
        class="nav-item"
        @click="expanded = false"
      >
        <component :is="item.icon" :size="18" :stroke-width="1.8" />
        <span>{{ item.label }}</span>
          <span v-if="item.to === '/app/connections' && required" class="nav-item__badge">{{ required }}</span>
      </RouterLink>
    </nav>

    <div class="sidebar__bottom">
      <RouterLink class="nav-item" to="/app/settings">
        <Settings :size="18" :stroke-width="1.8" />
        <span>Settings</span>
      </RouterLink>
      <div class="foundation-chip">
        <CircleGauge :size="15" />
        <div>
          <strong>Advisor</strong>
          <span>Phase 10 active</span>
        </div>
      </div>
    </div>
  </aside>
</template>
